import { Filter } from 'pixi.js';
import { shader } from './shader.js';

class HslAdjustmentFilter extends Filter {
  _hue = 0

  static defaults = {
    hue: 0,
    saturation: 0,
    lightness: 0,
    colorize: false,
    alpha: 1
  }

  constructor(options) {
    super(null, shader)
    const options_ = Object.assign({}, HslAdjustmentFilter.defaults, options)

    Object.assign(this, options_)
  }

  /**
   * Hue (-180 to 180)
   * @default 0
   */
  get hue() {
    return this._hue
  }

  set hue(value) {
    this._hue = value
    this.uniforms.uHue = this._hue * (Math.PI / 180) // convert degrees to radians
  }

  /**
   * Alpha (0-1)
   * @default 1
   */
  get alpha() {
    return this.uniforms.uAlpha
  }

  set alpha(value) {
    this.uniforms.uAlpha = value
  }

  /**
   * Colorize (render as a single color)
   * @default false
   */
  get colorize() {
    return this.uniforms.uColorize
  }

  set colorize(value) {
    this.uniforms.uColorize = value
  }

  /**
   * Lightness (-1 to 1)
   * @default 0
   */
  get lightness() {
    return this.uniforms.uLightness
  }

  set lightness(value) {
    this.uniforms.uLightness = value
  }

  /**
   * Saturation (-1 to 1)
   * @default 0
   */
  get saturation() {
    return this.uniforms.uSaturation
  }

  set saturation(value) {
    this.uniforms.uSaturation = value
  }
}

export { HslAdjustmentFilter }
